import React, { useState, useEffect } from 'react';
import styled from '@emotion/styled';

import { Link, NavLink, useLocation, useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import { logout } from '../../redux/actions/AuthActions';
import { isLoggedInCustomer, logoutCustomer } from '../../utils/auth';

import LoginMenu from './LoginMenu';
import ProductsLanding from '../Products/Landing';

const MenuWrapper = styled.div`
	z-index:99;
	display: flex;
	height: var(--header-height);
	align-items: center;
	width: 100%;
	max-width: var(--app-max-width);
	position: relative;
	white-space: nowrap;
	list-style: none;
	.LoginMenu {
		position: absolute;
		right: 0;
		margin-top: 0.5rem;
		display: grid;
		top: var(--space-32);
		text-indent: 1rem;
		grid-auto-flow: row;
		background-color: var(--color-white);
		border: 1px solid var(--color-gray-300);
		color: var(--company-dark);
		width: 14.875rem;
		height: 13.625rem;
		box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.15),
			0px 1px 2px rgba(0, 0, 0, 0.12);
		border-radius: 8px;
	}

	.show {
		display: block;
	}
	.active{
		color: var(--company-dark) !important;
		list-style: disc;
	}

	/* .active::before{
			content:"",
			display: inline-block;
			background-color: var(--company-dark);
			width: 10rem;
			height: 10rem;
			top: 2rem;
			border-radius: 100%;
			position: absolute;
			
		} */


	.menu-link {
		position: relative;
		padding: var(--space-10) var(--space-16);
		font-size:1.2rem;
		font-weight: 500;
		color: var(--color-gray-900);
		border-radius: 2.25rem;
		background-color: transparent;
		transition: background-color 0.3s ease-in-out;

		&:hover {
			background-color: var(--color-gray-100);
		}
		&:active {
			background-color: var(--color-gray-200);
			color: var(--company-dark);
		}

		&.shopping-cart {
		    display: flex;
		    align-items: center;
			color: var(--color-white);
			background-color: var(--company);
			box-shadow: var(--company-button-shadow);
			font-size: var(--font-16);
			font-weight: 500;
			/* height:10px; */

			> img {
				margin-right: var(--space-8);
			}
			>span{
				font-family:Inter,sans-serif;
			}
			&:hover {
				background-color: var(--company-dark);
			}
			&:focus {
				background-color: var(--company-dark);
			}
		}
		
		&.sign-in {
			background-color: var(--color-white);
			text-transform:uppercase;
			font-size:var(--font-14);
			font-weight:600;
			color:var(--company-dark);
			box-shadow: inset 0 0 0 1px var(--color-gray-300);
			&:hover {
				background-color: var(--color-gray-100);
			}
		}
		&.call {
			border-radius: var(--space-4);
			padding: var(--space-10) var(--space-10);
		}
	}


	.navbar--toggler-icon {
		display: none;
	}



	@media only screen and (max-width: 768px) {
		width: 100%;
		flex-direction: row;
		.navbar--toggler-icon {
			width: 2.5rem;
			height: 2.5rem;
			display: flex;
			justify-content: center;
			border: 1px solid var(--color-gray-500);
			border-radius: var(--space-6);
			background-color:var(--color-white);
		}
		.close {
			width: var(--space-40);
			height: var(--space-40);
			left: 8rem;
			background: #525b64;
			/* default/gray/300 */
			color: var(--color-white);
			border: 1px solid #d3d9de;
			box-sizing: border-box;
			border-radius: var(--space-6);
		}
		.top--nav {
			display: none;
		}
		.LoginMenu {
			display: none;
		}
	}
`;

const MenuButton = styled.a`
	padding: var(--space-10) var(--space-16);

	font-weight: 400;
	color: var(--color-gray-800);
	border-radius: 2.25rem;
	background-color: transparent;
	transition: background-color 0.3s ease-in-out;

	&:hover {
		background-color: var(--color-gray-100);
	}
	&:active {
		background-color: var(--color-gray-200);
	}
`;

const MenuContainer = styled.div`
	display: flex;
	align-items: center;
	width: 100%;

	@media only screen and (max-width: 768px) {
		width: 100%;
		justify-content: space-between;
		flex-direction: row;
		
	}
`;

const InnerMenuContainer = styled.div`
	display: flex;
	justify-content: space-between;
	flex-shrink: 1;
	align-items: center;
	width: 100%;

	.social-media{
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;

		width: 8.5rem;

	}

	@media only screen and (max-width: 768px) {
		display: none;
	}
`;

const SpacerLarge = styled.div`
	display: flex;
	flex-grow: 1;
	min-width: var(--app-horizontal-padding);
	align-items: center;
	height: var(--space-10);
	z-index: -1;
`;

const SpacerMenu = styled.div`
	width: var(--space-24);
	height: var(--space-10);
	z-index: -1;
`;

const Spacer = styled.div`
	width: var(--app-horizontal-padding);
	height: var(--space-10);
	z-index: -1;
`;

const Divider = styled.div`
	width: var(--space-2);
	height: var(--space-32);
	border-radius: var(--space-2);
	background-color: var(--color-gray-400);
`;

const Overlay = styled.div`

		z-index: 20;
		position: fixed;
		display: flex;
		width: 100%;
		height: 100%;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background-color: var(--color-white);
		cursor: pointer;
		flex-direction: column;
		justify-content: center;


	.nav-link {
		width: 10rem;
		padding-left: 2rem;
		font-size: var(--font-24);
		white-space:nowrap;
		color: var(--color-gray-700);
	}
	.nav-link:active {
		color: var(--company-dark);
	}
	.navbar--logo {
		width:10rem;
		align-self: center;
		margin-left:5.6%;
	}
	.btn-sign {
		display:flex;
		font-family: Inter,sans-serif;
		font-style: normal;
		font-weight: 500;
		font-size: var(--font-24);

		width: 15rem;
		padding-left: 2rem;
		color: var(--company-dark);
	}
	.signout{
		display: flex;
		padding: 1.5rem;

	> img{
		width: 2rem;
		height: 1.5rem;
		padding-left: 1rem;
	}
	}

	
	.overlay-mobile {
		z-index:6;
		margin-top: 1.1rem;
		display: flex;
		flex-direction: row;
		width: 100%;
		justify-content: space-between;
	}
	.overlay-inner-menu {
		position: relative;
		z-index: 30;
		display: flex;
		flex-direction: column;
		align-self: start;
		height: 100%;
		width: 100%;

		> .menu {
		z-index: 30;
		display: flex;
		flex-direction: column;
		margin-top: 3rem;
		height: 100%;
		justify-content: space-around;
		padding-left: 1rem;
	}
	}
	

	span {
		font-family: Inter;
		font-style: normal;
		font-weight: normal;
		font-size: var(--font-20);
		line-height: var(--space-24);
		/* identical to box height, or 100% */
		margin-left: 2.5rem;
		margin-bottom: 1rem;
		/* default/gray/900 */

		color: #222426;
	}

	@media only screen and (min-width: 768px) {
	
		.menu {
			align-self: center;
		}
	}
	@media only screen and (max-width: 500px) {
		.navbar--logo{
		margin-left:28.6%;
		}
	}
`;

const MobileDivider = styled.div`
	/* margin-left: 2.5rem; */
	width: 90vw;
	height: var(--space-2);

	/* default/gray/300 */

	background-color: var(--color-gray-300);
	border-radius: var(--space-2);
`;

const Mobile = styled.div`

	display: flex;
	align-items: center;

	.phone {
		display: flex;
		align-items: center;

		color: var(--color-gray-800) !important;
	}

	@media only screen and (max-width: 900px) {
		.phone {
			display: none;
		}
	}
`;

function Navbar({ auth, cart, logout }) {
	const location = useLocation();
	const history = useHistory();
	const [display, setDisplay] = useState(true);
	const [view, setView] = useState(false);
	const [active, setActive] = useState('active show');
	const [pos, setPos] = useState('relative');

	console.log("page", location.pathname);

	const change = () => {
		setDisplay(false);
		logoutCustomer();
	};

	const openOverlay = () => {
		setDisplay(false);
		setView(true);
		setPos('fixed');
	};
	const closeOverlay = () => {
		setDisplay(true);
		setView(false);
		setPos('relative');
	};

	const MenuLink = ({ to, title }) => {
		return (
			<NavLink className="menu-link" activeClassName="active" to={to}>
				{/* {' '} */}
				{/* <img
					style={{ display: 'none' }}
					src={'/img/svg/indicator.svg'}
				/> */}
				<li>{title}</li>
			</NavLink>
		);
	};

	return (
		<>
			<MenuWrapper style={{ position: pos }}>
				<Spacer />
				<MenuContainer>
					{console.log(auth)}
					<Link to="/landing" alt="to homepage" className="navbar--logo" tabIndex="0" role="button" onClick={() => closeOverlay()}>
					{/* <Link to="/coming-soon" alt="to homepage" className="navbar--logo" tabIndex="0" role="button" onClick={() => closeOverlay()}> */}
						<img
							alt="Home"
							src="/irad-logo.svg"
							width="135px"
							height="50px"
						/>
					</Link>
					{/*User Dropdown Menu*/}
					<InnerMenuContainer>
						<SpacerLarge />

						<MenuLink to={'/products'} title={'Products'} tabIndex="0" />

						<SpacerMenu />
						<MenuLink to={'/about'} title={'About'} tabIndex="0" />
						<SpacerMenu />
						<MenuLink to={'/contact'} title={'Contact Us'} tabIndex="0" />
						<Mobile className="phone">
							<SpacerMenu />
							<Divider />
							<SpacerMenu style={{ width: '18px' }} />
							<a href="tel:+18767547688" className="menu-link call" tabIndex="0">
								876-754-7688
							</a>
						</Mobile>
						<SpacerMenu style={{ width: '18px' }} />

						{isLoggedInCustomer(auth) && location.pathname !== '/landing' ? (
							<LoginMenu auth={auth} logout={logout} />
						) : (
							<>
								<Link className="menu-link sign-in" to={'/login'} tabIndex="0">
									Sign In
								</Link>
							</>
						) ?
							<div className="social-media">
								<img src="/img/svg/twitter.svg" />
								<a href='https://www.instagram.com/iradjamaica/'>
									<img style={{ height: "24px", width: "24px" }} src="/img/svg/instagram.svg" />
								</a>
								<a href='https://www.facebook.com/iradjamaica/'>
									<img src="/img/svg/facebook.svg" />
								</a>
							</div> :
							null
						}
						<SpacerMenu />
						{!isLoggedInCustomer(auth) && location.pathname === '/landing' ?
							null
							:
							isLoggedInCustomer(auth) && location.pathname !== '/landing' ?
								<Link className="menu-link shopping-cart" to={'/cart'}>
									<img src="/icons/shopping-cart.svg" />
									<span>
										{cart && cart.variants ? cart.variants.reduce((acc, val) => acc + val.quantity, 0) : 0}
									</span>
								</Link>
								: null
						}
					</InnerMenuContainer>

					{display ?

						<button className="navbar--toggler-icon" onClick={() => openOverlay()}>
							<img
								style={{ width: '1rem' }}
								src="/img/svg/menu.svg"
								alt="menu"
							/>
						</button>
						:
						<button className="close" onClick={() => closeOverlay()}>
							<img src="/icons/close.svg" alt="close icon" />
						</button>
					}

				</MenuContainer>
				<Spacer />
			</MenuWrapper>

			{view ?
				<Overlay>
					<WaveOne/>
					<div className="overlay-inner-menu">

						<div className="menu">
							<Link
								onClick={() => closeOverlay()}
								to={'/landing'}
								className="nav-link"
							>
								Home
							</Link>

							<Link
								onClick={() => closeOverlay()}
								to={'/products'}
								className="nav-link"
							>
								Products
							</Link>

							{/* <li className="nav-item ">
								<Link to={"/learning-center"} className="nav-link">
									Learning Centre
								</Link>
							</li> */}

							<Link
								onClick={() => closeOverlay()}
								to={'/about'}
								className="nav-link"
							>
								About
							</Link>

							<Link
								onClick={() => closeOverlay()}
								to={'/contact'}
								className="nav-link"
							>
								Contact Us
							</Link>

							{!isLoggedInCustomer(auth) ? (
								<div style={{
									display: 'flex',
									flexDirection: 'column',
									height: '4rem',
									justifyContent: 'space-between'
								}}>
									<MobileDivider />
									<Link
										onClick={() => closeOverlay()}
										to={'/login'}
									>
										<span className="btn-sign" style={{ paddingLeft: '0.1rem' }}>Sign In</span>
									</Link>
								</div>
							) : (
								<>
									<Link
										onClick={() => closeOverlay()}
										to={'/profile'}
										className="btn-sign"
									>
										View Profile
									</Link>
									<Link className="btn-sign" to={'/cart'} onClick={() => closeOverlay()}>
										View Cart {cart && cart.variants ? cart.variants.reduce((acc, val) => acc + val.quantity, 0) : 0}
									</Link>
									<div
										style={{
											display: 'flex',
											flexDirection: 'column'

										}}
									>
										<span style={{ fontFamily: 'Inter,sans-serif' }}>
											{auth.first_name + ' ' + auth.last_name}
										</span>
										<span
											style={{
												color: '#6E7B87',
												fontSize: '20px',
												fontFamily: 'Inter,sans-serif'
											}}
										>
											{auth.email}
										</span>
										<MobileDivider />
										<div
											onClick={() => {closeOverlay(); history.push('/landing'); logout()}}
											className="btn-sign signout"
										>
											<img
												src="/icons/logout.svg"
												alt="logout icon"
											/>
											Sign Out
										</div>
									</div>
								</>
							)}
						</div>
					</div>
				</Overlay>
				:
				null
			}
		</>
	);
}

const WaveOne = styled.div`
	display: none;
	@media only screen and (max-width: 1024px){
		background-image: url('/page-decor/product-top-swirl.png');
		background-repeat: no-repeat;
		background-position-x: left;
		background-position-y: top;
		position: absolute;
		width: 70vw;
		height: 57vh;
		bottom: 70%;
		left: 20%;
		z-index: 31;
    }
`;

const mapStateToProps = (state) => ({
	auth: state.auth,
	cart: state.cart,
});
const mapDispatchToProps = { logout };

export default connect(mapStateToProps, mapDispatchToProps)(Navbar);
